var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223 622 c-109 -39 -178 -112 -210 -221 -29 -102 4 -228 82 -306 122 -121 328 -121 450 0 91 92 118 241 64 356 -69 146 -241 223 -386 171z m193 -39 c66 -22 145 -101 167 -167 33 -98 13 -203 -53 -278 -39 -45 -115 -92 -132 -82 -4 3 -8 28 -8 55 0 28 -5 59 -10 70 -9 15 -7 19 7 19 32 0 84 40 99 75 18 44 18 73 -1 109 -8 15 -15 44 -15 63 0 34 -1 35 -27 28 -36 -11 -210 -11 -245 0 -27 7 -28 6 -28 -28 0 -19 -7 -48 -15 -63 -18 -36 -19 -65 -2 -107 17 -39 36 -55 82 -71 33 -12 34 -13 19 -34 -21 -30 -48 -28 -84 8 -41 40 -68 42 -36 3 8 -10 23 -29 34 -42 13 -17 29 -24 50 -24 28 0 32 -4 32 -28 0 -38 -10 -41 -58 -17 -58 28 -119 100 -137 161 -33 111 -10 203 70 283 80 80 183 104 291 67z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github-icon.c5aa58ec1eff5dd4586c5688252422ae.svg";
export { ForwardRef as ReactComponent };